<template>
    <icon-base v-bind="$props">
        <path d="M14 3v4a1 1 0 0 0 1 1h4" />
        <path
            d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
        />
        <path d="M12 17v-6" />
        <path d="M9.5 14.5l2.5 2.5l2.5 -2.5" />
    </icon-base>
</template>

<script setup>
import IconBase, { iconProps } from './IconBase.vue'

defineProps(iconProps)
</script>
